import Vue from 'vue';
import { normalizeKey } from '@/helpers';
import { ECOMMERCE_B2C, SHOPIFY } from '@/helpers/constants/Bundles';
export default Vue.extend({
    computed: {
        bundle() {
            const { key } = this.$router.currentRoute.params;
            return normalizeKey(key || '');
        },
        isB2c() {
            const b2cKey = normalizeKey(ECOMMERCE_B2C).toLowerCase();
            const shopifyKey = normalizeKey(SHOPIFY).toLowerCase();
            const key = this.bundle.toString().toLowerCase();
            return key === b2cKey || key === shopifyKey;
        },
    },
});
